import React, { Component } from 'react';
import OpcionBuscadorModelos from './OpcionBuscadorModelos';
 
class BuscadorModelosContables extends Component {
    constructor(props) {
        super(props);

        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarModelos = this.buscarModelos.bind(this);
    }

    buscarModelos(event) {
        let valorInput = event.target.value;

        this.props.buscarModelosContables(valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarModelosContables("");
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const {
            checkTodosModelos,
            inputBuscadorModelos,
            modelosContablesFiltrados
        } = this.props;

        //ACTIONS
        const {
            cambiarCheckAsientosContables,
            guardarQuitarModeloSeleccionado
        } = this.props;

        let arrayModelosContables = [];


        modelosContablesFiltrados && modelosContablesFiltrados.map(modelo => {
            arrayModelosContables.push(
                <OpcionBuscadorModelos
                    guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}

                    key={modelo.Id}
                    modelo={modelo}
                />
            );
        });

        arrayModelosContables = arrayModelosContables.length == 0 && !checkTodosModelos ? 
                                    <div className="ABMModelos__opcionBuscadorCuentasContablesSinResultados ContabilizadorRecontabilizador__sinResultadosBuscadorModelosContables">No se encontraron resultados</div>
                                : 
                                    arrayModelosContables;

        let estaHabilitado = Boolean(!checkTodosModelos);

        return (
            <div>
                <div className="ContabilizadorRecontabilizador__contenedorCheckTodosModelos">
                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                        <input id={"checkTodosModelos"} type="checkbox" checked={checkTodosModelos} onChange={() => cambiarCheckAsientosContables("checkTodosModelos", !checkTodosModelos)} />
                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkTodosModelos ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkTodosModelos"}></label>
                    </div>
                    <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__checkboxLabelHabilitado ContabilizadorRecontabilizador__labelCheckTodosModelos"}>Seleccionar todos los modelos</label>
                </div>


                <div className="ContabilizadorRecontabilizador__contenedorBuscadorModelosSeleccionados">
                    <div className="col-md-12 seccionSuperior__buscador ContabilizadorRecontabilizador__contenedorBuscadorInputModelosSeleccionados AsientosContables--floatLeft">
                        <div className={"AsientosContables--floatLeft seccionSuperior__iconoLupa" + (estaHabilitado ? "" : " seccionSuperior__iconoLupaDeshabilitado")}></div>

                        <div className="AsientosContables--floatLeft AsientosContables__contenedorInputBuscadorModelos">
                            <input 
                                id="buscarModeloContable"
                                className={"textbox-rectangular form-control default-input top-separator-xxxs seccionSuperior__inputBuscador" + (estaHabilitado ? "" : " ABMModelos__buscadorCuentasContables--deshabilitado")}
                                disabled={!estaHabilitado}
                                name="buscarModeloContable"
                                value={inputBuscadorModelos}
                                onChange={estaHabilitado ? this.buscarModelos : null}
                                onKeyDown={null}
                                onFocus={null}
                                onKeyPress={estaHabilitado ? this.onKeyPress : null}
                                placeholder={estaHabilitado ? "Buscar por código o descripción" : "Ya se seleccionaron todos los modelos"}
                            />
                        </div>
                    </div>
                    

                    {inputBuscadorModelos.length > 0 ?
                        <div className="seccionSuperior__botonBuscador ContabilizadorRecontabilizador__contenedorBotonLimpiarBusqueda AsientosContables__botonLimpiarBuscadorModelos AsientosContables--floatLeft">
                            <button type="button" className="btn-tag seccionSuperior__botonBorrarBusqueda ContabilizadorRecontabilizador__BotonLimpiarBusqueda"
                                onClick={this.limpiarBusqueda}>
                                <span className="ti-close span-closable" />
                            </button>
                        </div>
                    :
                        null
                    }
                </div>
                <div className="modalLogIntentosScroll AsientosContables__scrollModelosSeleccionados">
                    {arrayModelosContables}
                </div>
            </div>
        );
    }
};

export default BuscadorModelosContables
